import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BreadcrumbsBg from "../Assets/img/breadcrumbs-bg.png";
import HotlineIcon from "../Assets/img/hotline-icon.svg";
import WhatsAppIcon from "../Assets/img/whatsapp-icon.svg";
import MesssengerIcon from "../Assets/img/messenger-icon.svg";
import AdmissionProcess from "../Components/AdmissionProcess";

const AdmissionGuideline = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section
        className="eschool-breadcrumbs"
        style={{ backgroundImage: `url(${BreadcrumbsBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="eschool-breadcrumbs-content">
                <h3 className="eschool-bread-cont-title">
                  Admission Guideline
                </h3>
                <ul className="eschool-bread-menu">
                  <li>
                    <Link to="/">Home</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li className="active">
                    <Link to="/admissionguideline">Admission Guideline</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="eschool-admission-guideline">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-12">
              <div className="admission-guideline-content">
                <h3 className="admission-guideline-cont-title">
                  Admission open for session <br />
                  2022-2023
                </h3>
                <p className="admission-guideline-cont-text">
                  it is a long established fact that a reader will be distracted
                  by the readable content of a page when looking at its layout.
                  The point of using Lorem Ipsum is that it has a more-or-less
                  normal distribution of letters, as opposed to using 'Content
                  here, content here', making it look like readable English.
                  Many desktop publishing packages and web page editors now use
                  Lorem Ipsum as their default model text.
                </p>
                <p className="admission-guideline-cont-text m-0">
                  Many desktop publishing packages and web page editors now use
                  Lorem Ipsum as their default model text, and a search for
                  'lorem ipsum' will uncover many web sites still in their
                  infancy. Various versions have evolved over the years,
                  sometimes by accident, sometimes on purpose (injected humour
                  and the like).
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <div class="admission-guideline-img">
                <img src="https://via.placeholder.com/656x420" alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="admission-hotline-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1  col-xl-6 offset-xl-3 col-md-10 offset-md-1 col-12">
              <div className="admission-hotline-content">
                <h3 className="admission-hotline-cont-title">
                  Looking for more information about admission, please call or
                  chat !
                </h3>
                <div className="admission-hotline-main">
                  <ul className="admission-hotline-title">
                    <li>
                      <a href="tel:+8801234567890">
                        <img src={HotlineIcon} alt="#" />
                        Hotline Number-1
                      </a>
                    </li>
                    <li>
                      <a href="tel:+8801234567890">
                        <img src={HotlineIcon} alt="#" />
                        Hotline Number-2
                      </a>
                    </li>
                  </ul>
                  <div className="admission-hotline-btn">
                    <a
                      href="#"
                      className="eschool-btn whatsapp-btn"
                      target="_blank"
                    >
                      <img src={WhatsAppIcon} alt="#" />
                      Chat with WhatsApp
                    </a>
                    <a
                      href="#"
                      className="eschool-btn messenger-btn"
                      target="_blank"
                    >
                      <img src={MesssengerIcon} alt="#" />
                      Chat with Messenger
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <AdmissionProcess />
    </>
  );
};

export default AdmissionGuideline;
